<template>
  <v-dialog width="750" v-model="showBonusLogDialog">
    <v-card>
      <v-card-title class="heading py-2">
        <span class="text-h6 font-weight-medium"> Logs </span>
        <v-spacer></v-spacer>
        <v-btn icon @click="showBonusLogDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-2 Cards-Height-Class">
        <v-timeline dense clipped>
          <v-timeline-item
            v-for="(log, i) in allLogsList"
            :key="i"
            icon-color="primary"
            small
          >
            <v-card class="elevation-2">
              <v-card-text>
                <table class="Full-Width">
                  <tbody>
                    <tr>
                      <th class="text-left">{{ log.updated_by }}</th>
                      <td class="text-caption text-right">
                        {{ log.created | formatDate(true) }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">{{ log.message }}</td>
                    </tr>
                  </tbody>
                </table>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    bonusPayoutLogID: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      allLogsList: [],
    };
  },
  computed: {
    showBonusLogDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getDriverBonusProcessingLogs(this.bonusPayoutLogID);
      }
    },
  },
  methods: {
    getDriverBonusProcessingLogs(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.sapBonusPayout
        .getDriverBonusProcessingLogs(id)
        .then((res) => {
          this.allLogsList = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't fetch bonus payout logs!",
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>
